module.exports = [
    { "label": "Open", "value": "Open" },
    { "label": "Assigned", "value": "Pending" },
    { "label": "Solved", "value": "Solved" },
    { "label": 'Escalated', "value": 'Escalated' },
    // { "label": "Spam", "value": "Spam" },
    // { "label": "Archived", "value": "Archived" },
]